var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"menu-module-header"},[_c('div',{staticClass:"menu-module-title"},[_vm._v(_vm._s(_setup.composeModuleTitle(_vm.item)))]),(
			_vm.item.moduleId === 'north_south_funds' ||
			_vm.item.moduleId === 'margin_funds' ||
			_vm.item.moduleId === 'dividend_plan' ||
			_vm.item.moduleId === 'fund_holding'
		)?_c('div',{staticClass:"menu-module-right"},[_c('span',{staticClass:"unit-font"},[_vm._v(_vm._s(_setup.getCurrUnitTips))])]):_vm._e(),(_vm.item.moduleId === 'shareholder')?_c('div',{staticClass:"more-shareholder"},[_c('div',{staticClass:"menu-module-right"},[_vm._v(_vm._s(_setup.shareholdersWords))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }